import { type HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 font-medium whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "bg-intri-raised text-intri-dim border border-intri-border",
        accent: "bg-intri-accent-dim text-intri-accent border border-intri-accent/20",
        success: "bg-intri-success-dim text-intri-success border border-intri-success/20",
        error: "bg-intri-error-dim text-intri-error border border-intri-error/20",
        warning: "bg-intri-warning-dim text-intri-warning border border-intri-warning/20",
        info: "bg-intri-info-dim text-intri-info border border-intri-info/20",
        ghost: "bg-transparent text-intri-muted border border-transparent",
      },
      size: {
        sm: "text-2xs px-1.5 py-0.5 rounded-md",
        default: "text-xs px-2 py-0.5 rounded-md",
        lg: "text-sm px-2.5 py-1 rounded-lg",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <span
      className={cn(badgeVariants({ variant, size, className }))}
      {...props}
    />
  );
}
